
import { Image } from "element-ui"
import _ from "lodash"
import { addResizeListener, removeResizeListener } from "../../utils/resize-event"
import { formatImgUrl } from "../../utils/utils"
import { trackSelectPromotion, trackViewPromotion } from "@/utils/track"
import { getUserIdAndLabel } from "@/utils/userId"
const BANNER_WIDTH = 850
const LITTLE_BANNER_WIDTH = 653
const BANNER_SCALE = 1

export default {
  name: "CmsBanner",
  components: {
    [Image.name]: Image
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    initialIndex: {
      type: Number,
      default: 0
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    interval: {
      type: Number,
      default: 5000
    },
    loop: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isReady: false,
      activeIndex: -1,
      timer: null,
      hover: false,
      direction: "right"
    }
  },
  watch: {
    activeIndex(val, oldVal) {
      this.resetItemPosition(oldVal)
    },
    initialIndex(val) {
      this.resetItemPosition(val)
    }
  },
  mounted() {
    this.setActiveItem(this.initialIndex)
    this.$nextTick(() => {
      addResizeListener(this.$el, this.resetItemPosition)
      this.startTimer()
    })
    setTimeout(() => {
      this.isReady = true
    }, 4000)
  },
  beforeDestroy() {
    if (this.$el) removeResizeListener(this.$el, this.resetItemPosition)
    this.pauseTimer()
  },
  methods: {
    handleImgLoad(item, event) {
      // 图片加载成功
      if (item.uclid) {
        const { userId, customLabel } = getUserIdAndLabel()
        this.$onlineSalesSdk.registerAdImpressionEvent({
          cliUbid: userId,
          "f.custom_label_1": customLabel,
          uclid: item.uclid
        })
      }
    },
    handleArrowClick(direction, index) {
      this.isReady = true
      this.direction = direction
      this.setActiveItem(index)
    },
    handleMouseEnter() {
      this.hover = true
      this.pauseTimer()
    },
    handleMouseLeave() {
      this.hover = false
      this.startTimer()
    },
    checkVisibility() {
      const banner = this.$refs.banner
      if (!banner) {
        return false
      }
      const bannerPosition = banner.getBoundingClientRect()
      const isBannerInView = bannerPosition.bottom < 125
      const selectAddressDrawer = document.querySelector(".el-drawer__wrapper")
      const isSelectAddressVisible = selectAddressDrawer && selectAddressDrawer.style.display === ""
      return isSelectAddressVisible || isBannerInView
    },
    playSlides() {
      this.direction = "right"
      if (this.activeIndex < this.items.length - 1) {
        this.activeIndex++
      } else if (this.loop) {
        this.activeIndex = 0
      }
      this.trackViewPromotion(this.activeIndex)
    },

    pauseTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },

    startTimer() {
      if (this.interval <= 0 || !this.autoplay || this.timer) return
      this.timer = setInterval(this.playSlides, this.interval)
    },

    resetTimer() {
      this.pauseTimer()
      this.startTimer()
    },
    setActiveItem: _.throttle(function (index) {
      const length = this.items.length
      const oldIndex = this.activeIndex
      if (index < 0) {
        this.activeIndex = this.loop ? length - 1 : 0
      } else if (index >= length) {
        this.activeIndex = this.loop ? 0 : length - 1
      } else {
        this.activeIndex = index
      }
      if (oldIndex === this.activeIndex) {
        this.resetItemPosition(oldIndex)
      }
      if (!(this.hover && this.loop)) {
        this.resetTimer()
      }
      this.trackViewPromotion(this.activeIndex)
    }, 0),

    resetItemPosition(oldIndex) {
      this.items.forEach((item, index) => {
        const { translate, inStage, inStageLeft, inStageRight } = this.translateItem(index, this.activeIndex, oldIndex)
        this.$set(item, "_translate", translate)
        this.$set(item, "_inStage", inStage)
        this.$set(item, "_inStageLeft", inStageLeft)
        this.$set(item, "_inStageRight", inStageRight)
      })
    },
    translateItem(index, activeIndex, oldIndex) {
      const length = this.items.length
      if (index !== activeIndex && length > 2 && this.loop) {
        index = this.processIndex(index, activeIndex, length)
      }
      const inStage = Math.round(Math.abs(index - activeIndex)) <= 1
      return {
        inStage,
        inStageLeft: inStage && index - activeIndex < 0,
        inStageRight: inStage && index - activeIndex > 0,
        translate: this.calcTranslate(index, activeIndex, inStage)
      }
    },
    processIndex(index, activeIndex, length) {
      if (activeIndex === 0 && index === length - 1) {
        return -1
      } else if (activeIndex === length - 1 && index === 0) {
        return length
      } else if (index < activeIndex - 1 && activeIndex - index >= length / 2) {
        return length + 1
      } else if (index > activeIndex + 1 && index - activeIndex >= length / 2) {
        return -2
      }
      return index
    },
    calcTranslate(index, activeIndex, inStage) {
      const parentWidth = this.$el.offsetWidth
      const BANNER_WIDTH = parentWidth * 0.62 > 850 ? 850 : parentWidth * 0.62
      const LITTLE_BANNER_WIDTH = parentWidth * 0.48 > 650 ? 650 : parentWidth * 0.48
      if (inStage) {
        const gap = 12 * (index - activeIndex)
        if (index > activeIndex) {
          return parentWidth / 2 - BANNER_WIDTH / 2 + (index - activeIndex) * BANNER_WIDTH + gap
        }
        return parentWidth / 2 - BANNER_WIDTH / 2 + (index - activeIndex) * LITTLE_BANNER_WIDTH + gap
      } else if (index < activeIndex) {
        return (-(1 + BANNER_SCALE) * parentWidth) / 2
      } else {
        return ((3 + BANNER_SCALE) * parentWidth) / 2
      }
    },
    itemStyle(item) {
      const fontSize = process.client ? parseInt(getComputedStyle(document.documentElement).fontSize) : 10
      const value = `translateX(${item._translate / fontSize}rem)`
      return {
        transform: value
      }
    },
    formatImgUrl,
    formatLinkTo(item) {
      if (item.itemType === 15) {
        return {
          path: "/banner_home",
          query: {
            storeId: item.storeId
          }
        }
      }
      return item.resource
    },

    handleImageClick(item, index) {
      this.trackSelectPromotion(item, index)
      if (item.uclid) {
        const { userId, customLabel } = getUserIdAndLabel()
        this.$onlineSalesSdk.registerAdClickEvent({
          cliUbid: userId,
          "f.custom_label_1": customLabel,
          uclid: item.uclid
        })
      }
    },
    trackViewPromotion(index) {
      if (this.checkVisibility()) return
      trackViewPromotion(this.items[index], index)
    },
    trackSelectPromotion(item, index) {
      trackSelectPromotion(item, index)
    }
  }
}
